var $e73bf42412feb220$exports = {};
window.onload = function() {
    console.log("Loaded");
};


//# sourceMappingURL=index.7c3b941b.js.map
